/**
 * BT-GSD-KARATE-MEMBRES-IMPORT-001 — constantes d'import CKA 2025-26.
 */
export const CKA_IMPORT_BT_ID = "BT-GSD-KARATE-MEMBRES-IMPORT-001";
export const CKA_IMPORT_SOURCE = "CKA_2025_26_IMPORT";
export const CKA_SOURCE_FILE =
  "2026_CKA Individual Member registration form_ Formule dinscription pour membre individuel ACK(1-345).xlsx";
export const CKA_HEALTH_VERSION = "CKA-2025-26";
export const TO_COMPLETE = "À compléter";
export const EMAIL_TO_VERIFY = "Courriel à vérifier";
export const RICHARD_PIK_ID = "cka-etud-richard-pik";
export const RICHARD_PIK_MEMBERSHIP_ID = "cka-ms-richard-pik";

export const INSTRUCTOR_KEYS = Object.freeze({
  GILLES: "gilles-lavigne",
  YANNICK: "yannick-kammer",
  STEPHANE: "stephane-lachapelle",
  JAKI: "jaki-st-arnaud",
});

export const INSTRUCTOR_CATALOG = Object.freeze({
  [INSTRUCTOR_KEYS.GILLES]: {
    key: INSTRUCTOR_KEYS.GILLES,
    id: "inst-gilles-lavigne",
    nom: "Gilles Lavigne",
    titre: "Hanshi",
    organisation: "Shotokan",
    courriel: "shotokanaamc@gmail.com",
  },
  [INSTRUCTOR_KEYS.YANNICK]: {
    key: INSTRUCTOR_KEYS.YANNICK,
    id: "inst-yannick-kammer",
    nom: "Yannick Kammer-Mayer",
    titre: "Sensei",
    organisation: "Shotokan AAMC",
    courriel: "",
  },
  [INSTRUCTOR_KEYS.STEPHANE]: {
    key: INSTRUCTOR_KEYS.STEPHANE,
    id: "inst-stephane-lachapelle",
    nom: "Stéphane Lachapelle",
    titre: "Kyoshi",
    organisation: "Shotokan AAMC",
    courriel: "stephanelachapelle@hotmail.com",
  },
  [INSTRUCTOR_KEYS.JAKI]: {
    key: INSTRUCTOR_KEYS.JAKI,
    id: "inst-jacki-st-arnaud",
    nom: "Jaki St-Arnaud",
    titre: "Shihan",
    organisation: "Shotokan AAMC",
    courriel: "jaki-st-arnaud@hotmail.com",
  },
});

export const CANONICAL_DOJOS = Object.freeze({
  "aamc-gatineau": {
    id: "dojo-cka-aamc-gatineau",
    nom: "Karate Shotokan International AAMC - Gatineau",
    ville: "Gatineau",
    instructorKey: INSTRUCTOR_KEYS.GILLES,
  },
  "stephane-lachapelle": {
    id: "dojo-cka-stephane-lachapelle",
    nom: "Karaté Stéphane Lachapelle",
    ville: TO_COMPLETE,
    instructorKey: INSTRUCTOR_KEYS.STEPHANE,
  },
  "vdm": {
    id: "dojo-cka-shotokan-vdm",
    nom: "École de karaté Shotokan VDM",
    ville: "Val-des-Monts",
    instructorKey: INSTRUCTOR_KEYS.YANNICK,
  },
  "shotokan-gatineau": {
    id: "dojo-cka-shotokan-gatineau",
    nom: "Karaté Shotokan Gatineau",
    ville: "Gatineau",
    instructorKey: INSTRUCTOR_KEYS.JAKI,
  },
  "gracefield": {
    id: "dojo-cka-shotokan-gracefield",
    nom: "École Karaté Shotokan Gracefield",
    ville: "Gracefield",
    instructorKey: INSTRUCTOR_KEYS.STEPHANE,
  },
});

export const RICHARD_PIK = Object.freeze({
  firstName: "Richard",
  lastName: "Pik",
  phone: "819-918-5617",
  email: "rick-512@hotmail.com",
  instructorKey: INSTRUCTOR_KEYS.GILLES,
  organisation: "Shotokan AAMC",
});

export const KNOWN_EXISTING_PEOPLE = Object.freeze([
  {
    personKey: "gilles-lavigne",
    instructorId: "inst-gilles-lavigne",
    firstName: "Gilles",
    lastName: "Lavigne",
    email: "shotokanaamc@gmail.com",
    roles: ["instructor", "hanshi", "admin"],
  },
  {
    personKey: "marie-eve-caron",
    firstName: "Marie-Ève",
    lastName: "Caron",
    email: "marieeve793@hotmail.com",
    phone: "819-918-3677",
    roles: ["admin", "hanshi"],
  },
  {
    personKey: "marcel-charette",
    studentId: "seed-etud-marcel-charette",
    firstName: "Marcel",
    lastName: "Charette",
    email: "marcelfit@hotmail.ca",
    roles: ["student", "admin"],
  },
  {
    personKey: "natalie-lavigne",
    studentId: "seed-etud-natalie-lavigne",
    firstName: "Natalie",
    lastName: "Lavigne",
    roles: ["student"],
  },
  {
    personKey: "stephane-lachapelle",
    instructorId: "inst-stephane-lachapelle",
    firstName: "Stéphane",
    lastName: "Lachapelle",
    email: "stephanelachapelle@hotmail.com",
    roles: ["instructor"],
  },
  {
    personKey: "jaki-st-arnaud",
    instructorId: "inst-jacki-st-arnaud",
    firstName: "Jaki",
    lastName: "St-Arnaud",
    aliases: ["Jacki St-Arnaud", "Jaki St Arnaud"],
    email: "jaki-st-arnaud@hotmail.com",
    roles: ["instructor"],
  },
  {
    personKey: "dan-lepine",
    instructorId: "inst-dan-lepine",
    firstName: "Daniel",
    lastName: "Lépine",
    aliases: ["Dan Lepine", "Daniel lepine"],
    email: "danlepine70@gmail.com",
    roles: ["instructor"],
  },
]);
